 import React, {PropTypes} from 'react';
import CONSTANTS from '../common_constants';
import {getDateTime} from '../util/common';
import classNames from 'classnames';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import shipmentActions from './shipment_actions';
import PackageHandoff from './package_handoff_modal';
import PackageDelivery from './package_delivery_modal';
import authActions from '../auth/auth_actions';
import {Link, browserHistory} from 'react-router';
import ShowError from '../components/error/show_error';
import $ from 'jquery';

import Rating from 'react-rating';
import RatingPopup from '../components/rating_popup/rating_popup';

class CarrierProgressBar extends React.Component{
    constructor(props){
      super(props);
      const shipment = props.shipment && props.shipment.shipmentDetails;
      this.state = {
        isHandOffModalOpen: false,
        isDeliveryModalOpen: false,
        showMeetWithShipper: false,
        showMeetWithRecipient: false,
        error: '',
        showRatingPoup: false,
        shipment,
        showSucessPopup: false,
        showUploadPicture: false,
        showHandOffUploadPicture: false,
        showVerifyIdentityModal: false,
        showConfirmCodeModal: false,
        showReviewPopup: false,
        agentInfo:props.agentInfo
      };
      this.getCarrierStatusInfo = this.getCarrierStatusInfo.bind();
      this.showStartHandoff = this.showStartHandoff.bind();
      this.showDeliveryModal = this.showDeliveryModal.bind();
      this.startDelivery = this.startDelivery.bind();
      this.onMyWay = this.onMyWay.bind();
      this.reportADelay = this.reportADelay.bind();
    }

    componentWillReceiveProps(newProps){
      this.setState({"shipment":newProps.shipment.shipmentDetails,agentInfo:newProps.agentInfo});
    }

    getCarrierStatusInfo(shipment){
      let transportation;
      const arrivedAtDestnObj =  shipment.arrivedAtDestinationDateTime ? getDateTime(shipment.arrivedAtDestinationDateTime) : '';
      const deliveredDateObj = shipment.deliveredDate ? getDateTime(shipment.deliveredDate) : '';
      const onMyWayDateObj = shipment.onMyWayDateTime ?  getDateTime(shipment.onMyWayDateTime) : '';

      let pickupDateObj;
      if (shipment.shipmentStatus >=CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED && shipment.actualPickUpTime) {
        pickupDateObj = getDateTime(shipment.actualPickUpTime);
      }
      else if(shipment.shipmentStatus===CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED && shipment.pickupDateTime){
        pickupDateObj = getDateTime(shipment.pickupDateTime);
      }

      let deliveryDateObj;
      if (shipment.shipmentStatus<CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION && shipment.deliveryDateTime) {
        deliveryDateObj = getDateTime(shipment.deliveryDateTime);
      }
      else if(shipment.shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION && shipment.arrivedAtDestinationDateTime){
        deliveryDateObj = getDateTime(shipment.arrivedAtDestinationDateTime);
      }

      const transportType = CONSTANTS.carrierTransportType[shipment.carrierTransportType];
      if(transportType==="flight") transportation = transportType + " #" + shipment.flightNo;
      if(transportType==="car") transportation = transportType + " :" + shipment.carInfo.make + ", " + shipment.carInfo.model+ ", " + shipment.carInfo.color;
      if(transportType==="public transport") transportation = transportType + " #" + shipment.publicTransitInfo;

      return({
        pickupLocation: shipment.pickupLocation,
        pickupDate: pickupDateObj ? pickupDateObj.date : '',
        pickupTime: pickupDateObj ? pickupDateObj.time : '',
        deliveryDate: deliveryDateObj ? deliveryDateObj.date : '',
        deliveryTime: deliveryDateObj ? deliveryDateObj.time : '',
        onMyWayDate: onMyWayDateObj ? onMyWayDateObj.date : '',
        onMyWayTime: onMyWayDateObj ? onMyWayDateObj.time : '',
        deliveredDate: deliveredDateObj ? deliveredDateObj.date : '',
        deliveredTime: deliveredDateObj ? deliveredDateObj.time : '',
        transportation,
        deliveryLocation: shipment.deliveryLocation,
        shipmentStatus: shipment.shipmentStatus,
        handoffItemImages: shipment.handoffItemImages,
        recipientImages: shipment.recipientImages,
        isStartHandoff: shipment.isStartHandoff,
        deliveryLat: shipment.deliveryLat,
        deliveryLong: shipment.deliveryLong,
        pickupLat: shipment.pickupLat,
        pickupLong: shipment.pickupLong,
        isShipper: shipment.isShipper
      })
    }

    onClose = () => {
      this.setState({isLoading:true});

      this.setState({
        isHandOffModalOpen: false,
        error:"",
        isDeliveryModalOpen: false,
        showConfirmCodeModal: false,
        showVerifyIdentityModal: false,
        showUploadPicture: false,
        showHandOffUploadPicture: false,
        showMeetWithShipper: false,
        showMeetWithRecipient: false,
        showReviewPopup: false
      }, this.refreshCurrentPage());
    }

    showStartHandoff = (isShow) => {
      if(isShow) this.setState({showMeetWithShipper: true});
      else this.setState({isHandOffModalOpen: true});
    }

    showDeliveryModal = () => {

      const {shipmentStatus} = this.state.shipment;
      if(shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT){
        this.setState({showConfirmCodeModal: true});
      }
      else if(shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT){
        this.setState({showHandOffUploadPicture:true});
      }
      else if(shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION){
        this.setState({showVerifyIdentityModal: true});
      }
      else this.setState({isDeliveryModalOpen: true});
    }

    startHandoff = () => {
      const self = this;
      const {props,state} = this;
      const {shipmentId} = state.shipment;
      const paramObj = {"shipmentId": shipmentId};

      this.setState({isLoading:true});

      props.shipmentActions.startHandoff(paramObj).then(() => {
        self.setState({isLoading: false, error: '',showMeetWithShipper: true});
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false,showMeetWithShipper: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error});
        self.props.updateErrorState(errorRes.error);
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    }

    meetWithRecipient = () => {
      this.setState({showVerifyIdentityModal: true});
    }

    reportADelay = () => {
      const self = this;
      const {props,state} = this;
      const {shipmentId} = state.shipment;
      const paramObj = {"shipmentId": shipmentId};
      this.setState({isLoading:true});
      props.shipmentActions.reportADelay(paramObj).then(() => {
        self.setState({isLoading: false, error: ''});
        self.navigateToChat();
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error});
        self.props.updateErrorState(errorRes.error);
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    }

    navigateToChat = () => {
      const {state} = this;
      const {shipmentId} = state.shipment;
      const carrierId = state.shipment.carrierInfo.userId;
      const chatRedirectLink = "/inbox-chat/" + shipmentId + "/" + carrierId + "?backTo=" + "track-shipment";
      browserHistory.push(chatRedirectLink);
    }

    onMyWay = () => {
      const self = this;
      const {props,state} = this;
      const {shipmentId} = state.shipment;
      const paramObj = {"shipmentId": shipmentId};
      this.setState({isLoading:true});

      props.shipmentActions.onMyWay(paramObj).then(() => {
        self.setState({error: ''}, self.onClose, self.refreshCurrentPage);
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error});
        self.props.updateErrorState(errorRes.error);
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    }

    onImgUpload = (imgSrc) => {
      const self = this;
      const {state,props} = this;
      const {userData} = props.authState;

      this.setState({isLoading:true});
      let images = [];
      images.push(imgSrc);
      const paramObj = {
        shipmentId: state.shipment.shipmentId,
        images: images
      };

      props.shipmentActions.completeHandoff(paramObj).then(() => {

        if(userData.email) amplitude.getInstance().setUserId(userData.email);
        amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.ITEM_CARRY_HANDOFF_COMPLETE);

        self.setState({isLoading: false, error: '',showSucessPopup: true});
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error});
        self.props.updateErrorState(errorRes.error);
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    }

    onReciepentImgUpload = (imgSrc) => {
      const self = this;
      const {state,props} = this;
      this.setState({isLoading:true});
      // let images = [];
      // images.push(imgSrc);
      const paramObj = {
        shipmentId: state.shipment.shipmentId,
        recipientImg: imgSrc
      };

      props.shipmentActions.meetsRecipient(paramObj).then(() => {
        self.setState({isLoading: false, error: '',showConfirmCodeModal: true});
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error});
        self.props.updateErrorState(errorRes.error);
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    }

    startDelivery = () => {
      this.setState({showMeetWithRecipient: true});
    }

    arrivedAtDestination = () => {
      const self = this;
      const {props,state} = this;
      const {shipmentId} = state.shipment;
      const paramObj = {"shipmentId": shipmentId};
      this.setState({isLoading:true});

      props.shipmentActions.arrivedDestination(paramObj).then(() => {
        self.setState({isLoading: false, error: '', showVerifyIdentityModal: true});
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error});
        self.props.updateErrorState(errorRes.error);
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    }

    meetsRecipient = () => {
      const self = this;
      const {props,state} = this;
      const {shipmentId} = state.shipment;
      const paramObj = {"shipmentId": shipmentId};
      this.setState({isLoading:true});

      props.shipmentActions.meetsRecipient(paramObj).then(() => {
        self.setState({isLoading: false, error: ''});
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error});
        self.props.updateErrorState(errorRes.error);
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    }

    amAtPickupLocation = () => {
      const self = this;
      const {props,state} = this;
      const {shipmentId} = state.shipment;
      const paramObj = {"shipmentId": shipmentId};
      this.setState({isLoading:true});

      props.shipmentActions.amAtPickupLocation(paramObj).then(() => {
        self.setState({isLoading: false, error: '',showHandOffUploadPicture: true});
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error});
        //self.props.updateErrorState(errorRes.error);
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    }

    completeDelivery = (confirmCode) => {
      const self = this;
      const {props,state} = this;
      const {userData} = props.authState;
      const {shipmentId} = state.shipment;
      const paramObj = {
        "shipmentId": shipmentId,
        "secretCode": confirmCode
      };
      this.setState({isLoading:true});

      props.shipmentActions.completeDelivery(paramObj).then(() => {

        if(userData.email) amplitude.getInstance().setUserId(userData.email);
        amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.ITEM_CARRY_DELIVERY_COMPLETE);

        self.setState({
          isLoading: false,
          error: '',
          showConfirmCodeModal: false,
        },self.getReviewUserInfo)

      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error});
        self.props.updateErrorState(errorRes.error);
        $("html, body").animate({scrollTop: 0}, 1000);
      });
    }

    meetWithShipper = () => {
      this.amAtPickupLocation();
      showHandOffUploadPicture: true
    }

    onConfirmIdentity = () => {
      this.setState({showUploadPicture: true});
    }

    getReviewUserInfo = () => {
      const {shipment} = this.state;
      const {shipperInfo} = shipment;
      this.setState({showConfirmCodeModal: false, showReviewPopup: true});

      const user = {
        name: shipperInfo.name,
        imageUrl: shipperInfo.profileImgUrl || "../../public/images/user_placeholder.svg",
        totalNoOfRatings: shipperInfo.totalNoOfRatings,
        averageRating: shipperInfo.averageRating,
        shipmentId: shipment.shipmentId,
        userId: shipperInfo.userId,
        isShipper: shipment.isShipper,
        phoneNumber: shipperInfo.phoneNumber
      };
      this.setState({"user": user});
    }

    refreshCurrentPage = () => {
      window.location.reload(true);
      this.setState({isLoading: false});
    }

    render(){
      const { props, state } = this;
      const self = this;

      const { pickupLocation, pickupDate,
              pickupTime, transportation,
              deliveryDate, deliveryTime,deliveredDate,deliveredTime,
              deliveryLocation, shipmentStatus,
              handoffItemImages, recipientImages,isShipper,
              onMyWayDate, onMyWayTime, isStartHandoff,
              pickupLat,pickupLong,deliveryLat,deliveryLong
            } = this.getCarrierStatusInfo(state.shipment);

      let deliveryStatusBtn;

      if(shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT) deliveryStatusBtn = "Complete Delivery";
      else if(shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION) deliveryStatusBtn = "Confirm Identity";
      else deliveryStatusBtn = "Start Delivery";

      return(
        <div className = "progress-bar">
          {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
          <div className = "progress-steps-wrap">
            <div className = "connector"></div>
            <div className = "progress-steps">
              {
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED  &&
                  <span className = "outer-circle">
                    <span className = "circle inner-circle"></span>
                  </span>
              }
              {
                (
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE  ||
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY  ||
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION ||
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT ||
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED ) &&
                  <span className = "outer-circle step-completed">
                    <span className = "icon-check check-img"></span>
                  </span>
              }
              <span className = {classNames("step-name", {"active-step": shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED })}>Package Handoff<br/>
                <span className = "step-info desktopHide">
                  <span className = "location pickup-location">{pickupLocation}</span>
                  {
                    ( shipmentStatus<CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE &&
                    !isShipper ) &&
                    <div className = "">
                      <button className = "btn orange handoff-btn" onClick = {this.showStartHandoff.bind(self,isStartHandoff)}>{isStartHandoff ? "Meet with Shipper" : "Start Handoff"}</button>
                    </div>
                  }
                  {
                    handoffItemImages && handoffItemImages.length > 0 &&
                      <div className = "handoff-img-wrp img-wrp">
                        {
                          handoffItemImages.map( (imgSrc, idx) => {
                            return(
                              <img className = "handoff-img" src = {imgSrc} key = {idx} />
                            )
                          })
                        }
                      </div>
                  }
                </span>
              </span>
              <span className = "step-info responsiveHide">
                <span className = "location pickup-location">{pickupLocation}</span>
                {
                  (shipmentStatus<CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE &&
                  !isShipper) && <div className = "">
                    <button className = "btn orange handoff-btn"
                      onClick = {this.showStartHandoff.bind(self,isStartHandoff)}>{isStartHandoff ? "Meet with Shipper" : "Start Handoff"}
                    </button>
                  </div>
                }
                {
                  handoffItemImages && handoffItemImages.length > 0 &&
                    <div className = "handoff-img-wrp img-wrp">
                      {
                        handoffItemImages.map( (imgSrc, idx) => {
                          return(
                            <img className = "handoff-img" src = {imgSrc} key = {idx} />
                          )
                        })
                      }
                    </div>
                }
              </span>
              <span className = "step-info">
                <span className = "time-info date">{pickupDate}</span>
                {
                  pickupTime && <span className = "time-info">
                    <span className = "icon-clock clock-img"></span> {pickupTime}
                  </span>
                }
              </span>
            </div>
          </div>
          <div className = "progress-steps-wrap">
            <div className = "connector"></div>
            <div className = "progress-steps">
              {
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED  &&
                  <span className = "circle"></span>
              }
              {
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE  &&
                  <span className = "outer-circle">
                    <span className = "circle inner-circle"></span>
                  </span>
              }
              {
                ( shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY ||
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION ||
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT ||
                  shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED ) &&
                  <span className = "outer-circle step-completed">
                    <span className = "icon-check check-img"></span>
                  </span>
              }

              <div className = {classNames("step-name", {"active-step": shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE })}>Start Route
                <div className = "step-info desktopHide">
                  <div className = "transport-info">{transportation}</div>
                  {
                    shipmentStatus!=CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED && <div className = "on-my-way-wrap">
                    {
                        (shipmentStatus<CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY && !isShipper) &&
                            <button className = "btn orange on-my-way-btn"
                              onClick = {this.onMyWay.bind(self)}>I'm on my way</button>
                      }

                      {
                        !isShipper &&
                        shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE &&
                        shipmentStatus<CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT &&
                        <button className = "btn white report-a-delay"
                              onClick = {this.reportADelay.bind(self)}>Report a delay</button>
                      }
                    </div>
                  }
                </div>
              </div>
              <div className = "step-info responsiveHide">
                <div className = "transport-info">{transportation}</div>
                {
                  shipmentStatus!=CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED && <div className = "on-my-way-wrap">
                    {
                      (shipmentStatus<CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY && !isShipper) &&
                          <button className = "btn orange on-my-way-btn"
                            onClick = {this.onMyWay.bind(self)}>I'm on my way</button>
                    }

                    {
                      !isShipper &&
                      shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE &&
                      shipmentStatus<CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT && <button className = "btn report-a-delay"
                            onClick = {this.reportADelay.bind(self)}>Report a delay</button>
                    }
                  </div>
                }
              </div>

            </div>
          </div>
          <div className = "progress-steps-wrap">
            <div className = "connector"></div>
            <div className = "progress-steps">
              {
                (shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED  || shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE ) &&
                  <span className = "circle"></span>
              }
              {
                (shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY  || shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION  || shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT )&&
                  <span className = "outer-circle">
                    <span className = "circle inner-circle"></span>
                  </span>
              }
              {
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED  &&
                  <span className = "outer-circle step-completed">
                    <span className = "icon-check check-img"></span>
                  </span>
              }
              <span className = {classNames("step-name", {"active-step": shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY })}>Meet with Recipient
                <div className = "step-info desktopHide">
                  <div className ="location delivery-location">{deliveryLocation}</div>
                  {
                    shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY && !isShipper &&
                    shipmentStatus!=CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED && <div className = "on-my-way-wrap">
                      <button className = "btn orange start-delivery" onClick = {this.showDeliveryModal.bind(self)}>
                        {deliveryStatusBtn}
                      </button>
                    </div>
                  }
                  {
                      shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED && recipientImages && recipientImages.length > 0 &&
                      <span className = "recipient-img-wrp img-wrp">
                        {
                          recipientImages.map( (imgSrc, idx) => {
                            return(
                              <img className = "recipient-img" src = {imgSrc} key = {idx} />
                            )
                          })
                        }
                      </span>
                  }
                </div>
              </span>
              <div className = "step-info responsiveHide">
                <div className ="location delivery-location">{deliveryLocation}</div>
                  {
                    shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY && !isShipper &&
                    shipmentStatus!=CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED && <div className = "on-my-way-wrap">
                      <button className = "btn orange start-delivery" onClick = {this.showDeliveryModal.bind(self)}>
                        {deliveryStatusBtn}
                      </button>
                    </div>
                  }
                  {
                    shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED && recipientImages && recipientImages.length > 0 &&
                      <span className = "recipient-img-wrp img-wrp">
                        {
                          recipientImages.map( (imgSrc, idx) => {
                            return(
                              <img className = "recipient-img" src = {imgSrc} key = {idx} />
                            )
                          })
                        }
                      </span>
                  }
              </div>
              <span className = "step-info">
                <span className = "time-info date">{deliveryDate}</span>
                {
                  deliveryTime && <span className = "time-info">
                    <span className = "icon-clock clock-img"></span> {deliveryTime}
                  </span>
                }
              </span>
            </div>
          </div>
          <div className = "progress-steps-wrap">
            <div className = "progress-steps">
              {
                (shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED  || shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.HANDOFF_DONE  || shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.ON_THE_WAY  || shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_ARRIVES_AT_DESTINATION  || shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.CARRIER_MEETS_RECIPIENT  ) &&
                  <span className = "circle"></span>
              }
              {
                shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED  &&
                  <span className = "outer-circle step-completed">
                    <span className = "icon-check check-img"></span>
                  </span>
              }
              <span className = {classNames("step-name", {"active-step": shipmentStatus>=CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED })}>Delivery Confirmation<br/>
                <span className = "step-info desktopHide">Ask for confirmation code to confirm delivery</span>
              </span>
              <span className = "step-info responsiveHide">Ask for confirmation code to confirm delivery</span>
                {
                    shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED && <span className = "step-info">
                    <span className = "time-info date">{deliveredDate}</span>
                    <span className = "time-info">
                      <span className = "icon-clock clock-img"></span> {deliveredTime}
                    </span>
                  </span>
                }
            </div>
          </div>
        {
          (state.isHandOffModalOpen || state.showHandOffUploadPicture || state.showMeetWithShipper)&&
          <PackageHandoff
             isOpen={state.isHandOffModalOpen || state.showMeetWithShipper}
             onClose={this.onClose}
             startHandoff = {this.startHandoff}
             error = {state.error}
             isStartHandoff = {isStartHandoff}
             shipperInfo = {state.shipment.shipperInfo}
             onImgUpload = {this.onImgUpload}
             showMeetWithShipper = {state.showMeetWithShipper}
             showSucessPopup = {state.showSucessPopup}
             meetWithShipper = {this.meetWithShipper}
             showHandOffUploadPicture = {state.showHandOffUploadPicture}
             pickupLocation = {pickupLocation}
             pickupLat = {pickupLat}
             pickupLong = {pickupLong}
             authState = {this.props.authState}
          />
        }
        {
          ( state.isDeliveryModalOpen || state.showUploadPicture
            || state.showConfirmCodeModal || state.showVerifyIdentityModal || state.showMeetWithRecipient) &&
          <PackageDelivery
              isOpen={state.isDeliveryModalOpen || state.showConfirmCodeModal || state.showVerifyIdentityModal || state.showMeetWithRecipient}
              onClose={this.onClose}
              startDelivery = {this.startDelivery}
              error = {state.error}
              showConfirmCodeModal = {state.showConfirmCodeModal}
              completeDelivery = {this.completeDelivery}
              showVerifyIdentityModal = {state.showVerifyIdentityModal}
              recipientInfo = {state.shipment.recipientInfo}
              shipperInfo = {state.shipment.shipperInfo}
              onReciepentImgUpload = {this.onReciepentImgUpload}
              showUploadPicture = {state.showUploadPicture}
              onConfirmIdentity = {this.onConfirmIdentity}
              deliveryLocation = {deliveryLocation}
              meetWithRecipient = {this.meetWithRecipient}
              showMeetWithRecipient= {state.showMeetWithRecipient}
              arrivedAtDestination = {this.arrivedAtDestination}
              deliveryLat = {deliveryLat}
              deliveryLong = {deliveryLong}
              authState = {this.props.authState}
            />
        }
        {
          state.showReviewPopup && <RatingPopup
                                user = {state.user}
                                isOpen = {state.showReviewPopup}
                                onClose = {this.onClose}
                                />
        }
        </div>
      )
    }
}

CarrierProgressBar = connect((state) => {
  return {
    shipment: state.app.shipment,
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    shipmentActions: bindActionCreators(shipmentActions, dispatch)
  }
})(CarrierProgressBar);

module.exports = CarrierProgressBar;



// WEBPACK FOOTER //
// app/shipment/carrier_progress_bar.jsx